import { render } from "./task.vue?vue&type=template&id=7902fbd7"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
script.render = render

export default script